"use client";
import { jsx as p, Fragment as j, jsxs as E } from "react/jsx-runtime";
import { forwardRef as U, useRef as Z, useMemo as q, useState as B } from "react";
import "axios";
import { parseResourceText as K } from "./index38.js";
import { FormFieldError as L } from "./index4.js";
import { FormFieldHint as N } from "./index5.js";
const b = (o) => /^[A-Za-z0-9]?$/.test(o), G = U(
  ({
    value: o = "",
    onChange: F,
    length: n = 6,
    disabled: f = !1,
    inputMode: h = "text",
    autoComplete: S,
    error: D,
    statusType: d = "error",
    hint: I,
    ariaLabel: C = "Digito {{index}} de {{total}}.",
    uppercase: l = !1,
    ...z
  }) => {
    const y = Z(null), a = q(() => {
      const r = (o ?? "").toString().slice(0, n).split("");
      return Array.from({ length: n }).map((t, e) => r[e] ?? "");
    }, [n, o]), R = () => {
      const r = y.current;
      return r ? Array.from(r.querySelectorAll("input")) : [];
    }, c = (r) => {
      if (f)
        return;
      const t = R(), e = Math.max(0, Math.min(t.length - 1, r)), s = t[e];
      s && (s.focus(), g(!0), requestAnimationFrame(() => s.select()));
    }, w = () => {
      const r = a.findIndex((t) => !t);
      return r === -1 ? n - 1 : r;
    }, A = (r, t) => {
      if (!f) {
        if (t.preventDefault(), a[r]) {
          c(r);
          return;
        }
        c(w());
      }
    }, m = (r, t) => {
      console.log({ index: r, char: t });
      const e = l ? t.toUpperCase() : t;
      if (!b(e))
        return;
      const s = a.map((i, u) => u === r ? e : i);
      F(s.join(""));
    }, k = (r, t) => {
      if (t.key === "Backspace") {
        if (a[r]) {
          t.preventDefault(), m(r, "");
          return;
        }
        if (!a[r] && r > 0) {
          t.preventDefault();
          const e = r - 1;
          c(e), m(r - 1, "");
          return;
        }
      }
      if (t.key === "ArrowLeft" && r > 0) {
        t.preventDefault();
        const e = r - 1;
        c(e);
        return;
      }
      if (t.key === "ArrowRight" && r < ((o == null ? void 0 : o.toString().length) ?? 0) - 1) {
        t.preventDefault();
        const e = r + 1;
        c(e);
        return;
      }
    }, M = (r) => {
      r.preventDefault();
      const t = r.clipboardData.getData("text").replace(/[^A-Za-z0-9]/g, "").slice(0, n), e = l ? t.toUpperCase() : t;
      F(e);
      const s = Math.min(e.length, n - 1);
      c(s);
    }, [P, g] = B(!1);
    return /* @__PURE__ */ p(j, { children: /* @__PURE__ */ E("div", { className: "opt-pin-group otp-pin-ui", children: [
      /* @__PURE__ */ p(
        "div",
        {
          className: "otp-pin-wrp",
          ref: y,
          children: a.map((r, t) => /* @__PURE__ */ p(
            "input",
            {
              value: r,
              type: h,
              tabIndex: t > ((o == null ? void 0 : o.toString().length) ?? 0) - 1 ? -1 : 0,
              inputMode: h,
              autoComplete: S,
              maxLength: 1,
              placeholder: P && t === w() ? "" : "0",
              disabled: f,
              "aria-label": K(C, [
                String(t + 1),
                String(n)
              ]),
              onMouseDown: (e) => {
                A(t, e);
              },
              onTouchStart: (e) => {
                A(t, e);
              },
              onBlur: () => {
                g(!1);
              },
              onFocus: (e) => {
                g(!0), e.currentTarget.select();
              },
              onChange: (e) => {
                const i = e.target.value.replace(/[^A-Za-z0-9]/g, "").slice(-1), u = l ? i.toUpperCase() : i, T = u && t < n - 1 ? t + 1 : t;
                c(T), m(t, u);
              },
              onKeyDown: (e) => k(t, e),
              onPaste: M,
              ...z
            },
            t
          ))
        }
      ),
      /* @__PURE__ */ p(
        L,
        {
          id: "id-error-pin-otp",
          error: D,
          type: D ? d : void 0
        }
      ),
      /* @__PURE__ */ p(N, { id: "id-hint-pin-otp", hint: I })
    ] }) });
  }
);
export {
  G as OTPInput
};
